export default {
  notPredicted: "not_predicted",
  normal: "normal",
  abnormal: "malicious",
  covid: "pneumonia",
};
